export default {
  state: {
    testeos: [],
    trazabilidad: [],
  },
  mutations: {
    setTesteos(state, payload) {
      state.testeos = payload;
    },
    setTrazabilidad(state, payload) {
      state.trazabilidad = payload;
    },
  },
  getters: {
    getTesteos(state) {
      return state.testeos;
    },
    getTrazabilidad(state) {
      return state.trazabilidad;
    },
  },
};
